module.exports = __webpack_public_path__ + "static/media/soup.5be03fb4.jpg";